require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./recipes-christmas-mulled-wine.json") })
        }
      }, "path---recipes-christmas-mulled-wine");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---recipes-christmas-mulled-wine!./.cache/json/recipes-christmas-mulled-wine.json
// module id = 728
// module chunks = 231608221292675